var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlourescent401({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1.56,
    y: 8.75,
    className: "st2",
    width: 4.98,
    height: 0.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1.4,
    y: 6.69,
    className: "st2",
    width: 5.21,
    height: 0.5
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 9.25,
    y: 8.75,
    className: "st2",
    width: 5.21,
    height: 0.5
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 9.3,
    y: 6.69,
    className: "st2",
    width: 5.24,
    height: 0.5
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1.15,
    y: 7.43,
    className: "st2",
    width: 0.5,
    height: 2.01
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 14.2,
    y: 7.43,
    className: "st2",
    width: 0.5,
    height: 2.01
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M7.92,9.88c-1.07,0-1.95-0.87-1.95-1.95c0-1.07,0.87-1.95,1.95-1.95c1.07,0,1.95,0.87,1.95,1.95 C9.87,9.01,9,9.88,7.92,9.88z M7.92,6.49c-0.8,0-1.45,0.65-1.45,1.45c0,0.8,0.65,1.45,1.45,1.45c0.8,0,1.45-0.65,1.45-1.45 C9.37,7.13,8.72,6.49,7.92,6.49z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "8.52,8.66 7.2,7.38 7.37,7.2 8.69,8.48  "
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "7.37,8.66 7.2,8.48 8.52,7.2 8.69,7.38  "
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1.15,
    y: 6.43,
    className: "st2",
    width: 0.5,
    height: 2.01
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 14.2,
    y: 6.43,
    className: "st2",
    width: 0.5,
    height: 2.01
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlourescent401);
export default __webpack_public_path__ + "static/media/Flourescent4-01.cf3d1cc9a8a55c863313f63d4d9b28da.svg";
export { ForwardRef as ReactComponent };